import { GiveawayContributionApiClient } from '@fourthwall/services/dist/GiveawayContributionApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'
import { decodeHtmlEntities } from '@fourthwall/utils/dist/sanitize'

export const useGiveawayContributionsQuery = createQueryHook(
  GiveawayContributionApiClient.getGiveawayContributions,
  {
    queryKey: ['giveawayContributions'],
    select: (data) => {
      data.result = data.result.map((order) => ({
        ...order,
        supporter: {
          ...order.supporter,
          email: decodeHtmlEntities(order.supporter.email),
          username: order.supporter.username
            ? decodeHtmlEntities(order.supporter.username)
            : undefined,
        },
      }))

      return data
    },
  },
)
